import type { DashboardScope } from '@api/domain/types';

export enum DashboardDrilldownScope {
  Machine = 'machine',
  Customer = 'customer',
  Part = 'part',
  NcFile = 'ncFile',
}

export type DashboardDrilldownType = Exclude<DashboardDrilldownScope, DashboardDrilldownScope.NcFile>;

export enum DashboardDrilldownTab {
  List = 'list',
  Breakdown = 'breakdown',
  Trend = 'trend',
}

export interface DashboardDrilldownTabbedRouteParams {
  drilldownId: string;
  drilldownName?: string;
  childScope?: DashboardScope;
  tab?: DashboardDrilldownTab;
}

export interface DashboardDrilldownNcFileRouteParams {
  ncFileId: string;
  ncFileName?: string;
}
